import { error as toastError, success as toastSuccess } from "@/providers/ToastProvider";

export const toastTemplateSaved = (name: string, category: string) =>
  toastSuccess(`“${name}” saved as a template`, { description: `Filed under ${category}.` });

export const toastTemplateUpdated = (name: string) =>
  toastSuccess(`“${name}” updated`, { description: "Everywhere it is used sends the new wording." });

export const toastTemplateNotUpdated = () =>
  toastError("Template not updated", { description: "Something went wrong. Try again." });

export const toastTemplateTooLong = (maxLength: number) =>
  toastError("Template not loaded", { description: `This template is longer than ${maxLength} characters.` });

export const toastTemplateNotSaved = () =>
  toastError("Template not saved", { description: "Something went wrong. Try again." });

export const toastImageUploadFailed = () =>
  toastError("Image not attached", { description: "Something went wrong uploading the image. Try again." });
